import { render, staticRenderFns } from "./CouponManager.vue?vue&type=template&id=8d85c8cc&scoped=true&"
import script from "./CouponManager.vue?vue&type=script&lang=js&"
export * from "./CouponManager.vue?vue&type=script&lang=js&"
import style0 from "./CouponManager.vue?vue&type=style&index=0&id=8d85c8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d85c8cc",
  null
  
)

export default component.exports